import React, { useState } from 'react';
import { Box, Container, CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import ChatPanel from '../components/ChatPanel';
import DataPanel from '../components/DataPanel';
import { TripRecommendation } from '../api/tripService';

const MainLayout: React.FC = () => {
  const [tripData, setTripData] = useState<TripRecommendation | null>(null);

  const handleDataUpdate = (data: TripRecommendation | null) => {
    setTripData(data);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CssBaseline />
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Outlet />
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          gap: 3,
          height: '100%'
        }}>
          <Box sx={{ 
            flex: 1,
            minWidth: { md: '50%' }
          }}>
            <ChatPanel onDataUpdate={handleDataUpdate} />
          </Box>
          <Box sx={{ 
            flex: 1,
            minWidth: { md: '50%' }
          }}>
            <DataPanel data={tripData} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default MainLayout; 